import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismSelectInput } from '@mylighthouse/prism-ember';

// @ts-expect-error: Incorrect type
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function capitalizeFirstLetter(sentence) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
}

interface SettingsCentralMappingRoomtypeMappingCellRoomtypeSelectSignature {
  Args: {
    onSelectRoom: unknown;
    room: unknown;
    sortedSelections: unknown;
  };
}

export default class SettingsCentralMappingRoomtypeMappingCellRoomtypeSelect extends Component<SettingsCentralMappingRoomtypeMappingCellRoomtypeSelectSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get options() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.sortedSelections.map((room) => ({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      label: room.proper_name,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      room,
    }));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get value() {
    return {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      label: capitalizeFirstLetter(this.args.room.name),
    };
  }

  @action
  // @ts-expect-error: Incorrect type
  handleChange(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.onSelectRoom(option.room, this.args.room);
  }

  <template>
    <PrismSelectInput
      {{! @glint-expect-error: Incorrect type }}
      @dataEventId="hotel-roomtype-mapping-toggle-dropdown"
      @onChange={{this.handleChange}}
      @options={{this.options}}
      @unsafe_openOnClick={{true}}
      @value={{this.value}}
    />
  </template>
}
